'use client';

import { PressEventsType } from '@osmosis/backend/orm-db';
import { PROD_MEDIA_SERVER } from '@osmosis/constants';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import { H4 } from '@osmosis/tailwind-ui/components/Text';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { text3 } from '@osmosis/tailwind-ui/styles/text';
import dayjs from 'dayjs';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  event: PressEventsType;
};

/**
 * Current event item.
 */
const CurrentEventItem = (props: Props) => {
  const { event } = props;

  const handleClick = () => {
    if (event.data.registration_url) {
      window.open(event.data.registration_url);
    }
  };

  return (
    <Box
      id={event.data.anchor_id}
      cn="flex flex-col gap-2 p-2 rounded-lg hover:bg-slate-100 h-full justify-between cursor-pointer"
      onClick={handleClick}
      data-testid={`current-event-${event.eventId}-item`}
    >
      <Box cn="flex flex-col gap-2" data-testid={`current-event-item-wrapper`}>
        <Box cn="w-full relative p-[28.25%]">
          <Image
            src={`${PROD_MEDIA_SERVER}${event.data.image}`}
            fill={true}
            alt={`Event thumbnail for the ${event.data.title} webinar`}
            className="object-contain"
            // Make sure to adjust these sizes if the image sizes are changed to optimize image
            // performance
            sizes="(max-width: 640px) 39vw, (max-width: 1000px) 24vw, 245px"
          />
        </Box>
        <H3>{event.data.title}</H3>
        <H4 cn={`${text3}`}>{dayjs(event.Date).format('MMMM D, YYYY')}</H4>
        <P>{event.data.description}</P>
      </Box>
      <Box>
        <Button data-testid={`event-${event.eventId}-register-button`}>
          <FormattedMessage
            id="press-event-item.register"
            defaultMessage="Register"
          />
        </Button>
      </Box>
    </Box>
  );
};

export default CurrentEventItem;
